import axios from 'axios';

const operatorApi = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
});

operatorApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('evapp_operator_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default operatorApi;
